import React, {Component} from 'react';
import {connect} from 'react-redux';
import get from 'get-value';
import Loader from '../../Loader';
import {Redirect, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    fetchSparePartsInternalTicket,
    resetSparePartsInternalTicket,
    updateSparePartsInternalTicket
} from '../../../actions/orders/actionSparePartsInternalTicket';
import {transformUpdateSparePartsInternalTicketForSave} from '../Utils';
import {
    lockSparePartsInternalTicket,
    resetRedirectAfterSparePartsInternalLockTicket,
    unlockSparePartsInternalTicket
} from '../../../actions/orders/actionSparePartsInternalLockTicket';
import UploadingSparePartsInternalTicketAttachments from './UploadingSparePartsInternalTicketAttachments';
import checkRoles from '../../common/roleChecker/RoleChecker';
import EditLoadInternalTicketDataPage from './EditLoadInternalTicketDataPage';
import {
    FORM_BUTTON_ANSWER, FORM_BUTTON_ESCALATE, FORM_BUTTON_TRANSFER_TO_REQUESTOR,
    ORDER_INTERNAL_TICKET_STATUS_ANSWERED,
    ORDER_INTERNAL_TICKET_STATUS_IN_PROGRESS,
    ORDER_INTERNAL_TICKET_STATUS_NEW,
    ORDER_INTERNAL_TICKET_STATUS_REOPENED,
    ORDER_INTERNAL_TICKET_STATUS_TRANSFERRED
} from '../../../constants/formConstants';
import {moduleRoles} from '../../../utils/roles';
import {injectIntl} from 'react-intl';
import alertMessages from '../../../intl/common/alertMessages';

class EditSparePartsInternalTicketPage extends Component {
    constructor(props) {
        super(props);
        this.state = {ticketSubmittedAndShouldRedirect: false, createInternalTicket: false, skippedStatus: false, fetchedNewTicketData: false};
    }

    componentWillUnmount() {
        const {uuid, redirect} = this.props.lockTicket;
        if (!redirect) {
            this.props.unlockSparePartsInternalTicket(uuid);
        }
        this.props.resetRedirectAfterSparePartsInternalLockTicket();
    }

    componentDidMount() {
        this.props.resetSparePartsInternalTicket();
        this.props.lockSparePartsInternalTicket(this.props.match.params.ticketUuid);

        if (!this.props.location.redirectedAfterUpdate) {
            this.setState({fetchedNewTicketData: true});
            this.props.fetchSparePartsInternalTicket(this.props.match.params.ticketUuid);
        }
        if (!!this.props.location.checkStatusSkipAfterUpdateRedirect) {
            this.setState({fetchedNewTicketData: true});
        }
    }

    missingEditorsNotes = (submitBy, dataForSend) => {
        if (submitBy === FORM_BUTTON_ANSWER || submitBy === FORM_BUTTON_ESCALATE || submitBy === FORM_BUTTON_TRANSFER_TO_REQUESTOR) {
            return !dataForSend.message;
        }
    }

    answeredToSuspiciousGroup = (submitBy, dataForSend) => {
        if (submitBy === FORM_BUTTON_ANSWER) {
            const assignedSolutionGroup = get(dataForSend, 'ticket.assignedSolutionGroup.id');
            return !this.props.previousSolutionGroups.includes(assignedSolutionGroup)
        }
    }

    handleSubmit = (values) => {
        const {submitBy} = values;
        const dataForSend = transformUpdateSparePartsInternalTicketForSave(values);

        if (this.answeredToSuspiciousGroup(submitBy, dataForSend)) {
            const groupName = get(dataForSend, 'ticket.assignedSolutionGroup.name');

            if (!window.confirm(this.props.intl.formatMessage(alertMessages.ESCALATION_SUSPICIOUS_GROUP_WARN, {groupName}))) {
                return;
            }
        }
        if (this.missingEditorsNotes(submitBy, dataForSend)) {
            if (!window.confirm(this.props.intl.formatMessage(alertMessages.ESCALATION_MISSING_EDITORS_NOTES_GROUP_WARN))) {
                return;
            }
        }
        this.props.updateSparePartsInternalTicket(dataForSend);
        this.setState({ticketSubmittedAndShouldRedirect: true});
    };


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevState.ticketSubmittedAndShouldRedirect && !this.state.ticketSubmittedAndShouldRedirect
            && prevProps.ticketData.isTicketCreating && !this.props.ticketData.isTicketCreating
            && this.props.ticketData.isTicketLoading) {
            this.props.lockSparePartsInternalTicket(this.props.match.params.ticketUuid);
        }
    }

    render() {
        const {
            ticketData,
            attachmentsData,
            lockTicket,
            loggedUser
        } = this.props;

        if (lockTicket.redirect) {
            return <Redirect to={`/order/internalTicket/view/${lockTicket.uuid}`}/>;
        }

        let formType = false;
        if (get(ticketData, 'ticket.docType', {default: false})) {
            formType = ticketData.ticket.docType;
        }

        if (Array.isArray(attachmentsData.attachmentsForUpload) && (attachmentsData.attachmentsForUpload.length > 0)) {
            return <UploadingSparePartsInternalTicketAttachments attachments={attachmentsData.attachmentsForUpload}
                                                attachmentsUrl={ticketData.newAttachments}
                                                correlationId={ticketData.correlationId}
                                                isAttachmentUploading={attachmentsData.isTicketAttachmentUploading}
                                                formType={formType}/>
        }

        if (ticketData.isTicketLoading
            || ticketData.isTicketCreating
            || lockTicket.isTicketLocking
            || !formType
        ) {
            return <Loader/>;
        }

        if (this.state.ticketSubmittedAndShouldRedirect && !ticketData.isTicketCreating && !ticketData.isTicketLoading && get(ticketData, 'ticket.uuid', {default: false})) {
            return <Redirect to={{
                pathname: `/order/internalTicket/view/${ticketData.ticket.uuid}`,
                redirectedAfterUpdate: true
            }}/>;
        }

        if (get(ticketData, 'ticket.uuid', {default: false})
            && [ORDER_INTERNAL_TICKET_STATUS_NEW, ORDER_INTERNAL_TICKET_STATUS_ANSWERED, ORDER_INTERNAL_TICKET_STATUS_TRANSFERRED, ORDER_INTERNAL_TICKET_STATUS_REOPENED].includes(get(ticketData, 'ticket.status', {default: false}))
            && moduleRoles.isSGEditorOrderInSG(loggedUser, get(ticketData, 'ticket.assignedSolutionGroup.id', {default: ''}))
            && !this.state.skippedStatus
            && this.state.fetchedNewTicketData
        ) {
            this.setState({skippedStatus: true});
            this.props.updateSparePartsInternalTicket({
                ticket: {
                    pfxNumber: ticketData.ticket.pfxNumber,
                    sfxNumber: ticketData.ticket.sfxNumber,
                    status: ORDER_INTERNAL_TICKET_STATUS_IN_PROGRESS,
                    uuid: ticketData.ticket.uuid,
                }
            });
            return <Loader/>;
        }

        return (
            <EditLoadInternalTicketDataPage formType={formType} handleSubmit={this.handleSubmit}/>
        );
    }
}

const getPreviousSolutionGroups = (state) => {
    const logs = get(state, 'sparePartsInternalTicket.logs') || [];

    const fromIds = logs.map(item => item.solutionGroup && item.solutionGroup.id);
    const toIds = logs.map(item => item.toSolutionGroup && item.toSolutionGroup.id);

    return [...new Set([...fromIds, ...toIds])];
}

const mapStateToProps = (state) => ({
    loggedUser: state.profile.userDetail.roles,
    ticketData: state.sparePartsInternalTicket,
    lockTicket: state.sparePartsLockInternalTicketCheck,
    attachmentsData: state.sparePartsInternalTicketAttachment,
    previousSolutionGroups: getPreviousSolutionGroups(state)
});

EditSparePartsInternalTicketPage.propTypes = {
    location: PropTypes.object,
    ticketData: PropTypes.object.isRequired,
    fetchSparePartsInternalTicket: PropTypes.func.isRequired,
    resetSparePartsInternalTicket: PropTypes.func.isRequired,
    lockSparePartsInternalTicket: PropTypes.func.isRequired,
    unlockSparePartsInternalTicket: PropTypes.func.isRequired,
    resetRedirectAfterSparePartsInternalLockTicket: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    updateSparePartsInternalTicket: PropTypes.func.isRequired,
};

export default checkRoles(withRouter(connect(mapStateToProps, {
    fetchSparePartsInternalTicket,
    resetSparePartsInternalTicket,
    lockSparePartsInternalTicket,
    unlockSparePartsInternalTicket,
    resetRedirectAfterSparePartsInternalLockTicket,
    updateSparePartsInternalTicket,
})(injectIntl(EditSparePartsInternalTicketPage))), ['SP_SG_EDITOR']);

